<template>
    <newForm v-bind:title='$t("auditconfig_managment.audit_config")' className="col-xs-12">
        <div v-bind:class="[direction ? 'k-rtl' : '' ]">
            <grid v-bind:columns="columns"
                  v-bind:reloadGrid="reloadGrid"
                  dataSourceUrl="api/auditConfig/list"
                  v-bind:toolbar="toolbar"
                  hasPaging="true"
                  pagingType="numeric"
                  resizable="true"
                  selectable="false"
                  sortable="true"
                  editable="false">
            </grid>
        </div>
        <component v-show="showAuditModal"
                   :is="currentModalComponent"
                   v-bind:showAuditModal="showAuditModal"
                   v-bind:modalData="modalData">
        </component>
    </newForm>
</template>

<script  type="text/javascript">
    import NewForm from '../forms/newform/newForm.vue';
    import Grid from "../widgets/grid/grid.vue";    
    import ModalAuditConfig from './modals/ModalAuditConfig.vue';

  

    export default {
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                columns: [
                    { field: "AuditType", title: i18n.$t("auditconfig_managment.audit_type"), menu: false, hidden: false, sortable: true },
                    { field: "InfVal", title: i18n.$t("auditconfig_managment.inf_val"),  menu: false, hidden: false, sortable: true },
                    { field: "Id",title: i18n.$t("auditconfig_managment.id"), menu: false, hidden: false, sortable: true }

                ],
                toolbar: this.buildToolbarItems(),
                reloadGrid: 0,
                modalData: {},
                currentModalComponent: "",
                showAuditModal: 0
            }
        },
        methods: {
            buildToolbarItems() {
                let mapping = (value) => {
                    let hasSubActions = Array.isArray(value.subActions);
                    return {
                        type: hasSubActions ? "splitButton" : "button",
                        text: (value.icon) ? `<i class="${value.icon} fa-fw fa-lg"></i> ${value.text}` : value.text,
                        enable: value.enable,
                        click: value.action,
                        imageUrl: value.image,
                        menuButtons: hasSubActions ? value.subActions.map(mapping) : undefined
                    }
                };
                return this.getActions().map(mapping);
            },
            getActions() {
                return [
                    {
                        key: "AddAuditConfig",
                        text: this.$t("auditconfig_managment.add"),
                        icon: "far fa-plus-square",
                        action: (node, nodeData, selecteds) => {
                            this.modalData.isCreation = true;
                            this.currentModalComponent = "ModalAuditConfig";
                            this.modalData.callback = () => {
                                this.reLoadeData();
                            };
                            this.showAuditModal++;
                        },
                        enable: true
                    },
                    {
                        key: "EditAuditCongif",
                        text: this.$t("edit"),
                        icon: "far fa-edit",
                        action: (node, nodeData, selecteds) => {
                            debugger;
                            let dataItem = nodeData[0];
                            this.modalData.isCreation = false;                            
                            this.modalData.auditType = dataItem.AuditType;
                            this.currentModalComponent = "ModalAuditConfig";
                            this.modalData.callback = () => {
                                this.reLoadeData();
                            };
                            this.showAuditModal++;
                        },
                        enable: false
                    },
                    {
                        key: "DeleteAuditConfig",
                        text: this.$t("remove"),
                        icon: "far fa-trash-alt",
                        action: (node, nodeData, selecteds) => {
                            debugger;
                            let dataItem = nodeData[0];
                            var auditType = dataItem.AuditType;

                            var that = this;

                            confirm(i18n.$t("are_you_sure"), {
                                yes: function () {
                                    var url = "api/auditConfig/delete/" + auditType;

                                    that.doAjaxRequest(url, {}, () => { that.reLoadeData(); }, () => { }, 'DELETE');
                                },
                                no: function () { }
                            });
                        },
                        enable: false
                    }
                ];
            },
            reLoadeData() {
                this.reloadGrid++;
            },
            doAjaxRequest(url, data, onSuccess, onFailure, method) {
                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",

                    contentType: "application/json;charset=utf-8"
                };
                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        if (typeof onFailure === 'function') {

                            var response = null;

                            if (error.status == 400) {
                                response = JSON.parse(error.responseText);
                                onFailure(response);
                            }
                        }
                    });
            }
        },
        mounted() {
        },
        created() {
            console.log('new main');
        },
        components: {
            NewForm,
            Grid,
            ModalAuditConfig
        }
    }

</script>
